// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W3vET","primary":"Button_primary__BMJJP","secondary":"Button_secondary__IrKPV","btnCart":"Button_btnCart__tPay1","round":"Button_round__asCoh"};